import { connect } from 'react-redux';

import { checkForCountdown } from '../utils';
import CampaignHeader from './CampaignHeader';

const mapStateToProps = state => ({
  hasCountdownProducts: checkForCountdown(
    Object.values(state.campaignEditor.campaignLinesById),
  ),
  guardModified: state.changeGuard,
});

export default connect(mapStateToProps, null)(CampaignHeader);
